/**
 * The stored answer key of a wordle: the hidden word. Kept apart from the editor component
 * so the eagerly loaded module file never pulls the form into the bundle.
 */
import type { WordleDefinition } from "./types";

export interface WordleSolution {
  target: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function emptySolution(_definition: WordleDefinition): WordleSolution {
  return { target: "" };
}

/** Reads whatever is stored, however wrong, and keeps the string it can use. */
export function targetOf(value: unknown): string {
  if (!isRecord(value) || typeof value.target !== "string") return "";
  return value.target;
}
